export default __webpack_public_path__ + "static/fertilewinterbackground-87cb0cce967323f8ac4b959c4e745dd2.jpg";